import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/down.png'
import _imports_1 from '../assets/performance/banner_games_new.png'
import _imports_2 from '../assets/performance/taptap_banner.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-60fd26eb")

_pushScopeId("data-v-60fd26eb")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 刷新数据 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" TapTap刷新数据 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_7 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("自动填充")
const _hoisted_18 = { id: "perf_report" }
const _hoisted_19 = { class: "spacName" }
const _hoisted_20 = {
  key: 0,
  class: "banner",
  src: _imports_1,
  alt: ""
}
const _hoisted_21 = {
  key: 1,
  class: "banner",
  src: _imports_2,
  alt: ""
}
const _hoisted_22 = { style: {"font-size":"20px"} }
const _hoisted_23 = { style: {"margin-left":"30px"} }
const _hoisted_24 = { class: "spacName" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { style: {"display":"flex","margin-left":"50px","align-items":"center"} }
const _hoisted_27 = { class: "current_img" }
const _hoisted_28 = { style: {"font-weight":"bold","color":"black"} }
const _hoisted_29 = {
  key: 0,
  style: {"color":"#b7b7b7","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","width":"320px"}
}
const _hoisted_30 = {
  key: 1,
  style: {"color":"#b7b7b7"}
}
const _hoisted_31 = { class: "dialog-footer" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("确 认")
const _hoisted_34 = {
  key: 0,
  class: "backdrop"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "选择平台" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.type,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.type = $event)),
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dateChange(true)))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.type_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "选择日期" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.date,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.date = $event)),
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dateChange(false)))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.date_options, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.date,
                                  label: item.date,
                                  value: item.date
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "对比日期" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.old_date,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.old_date = $event)),
                            onChange: _ctx.dateOldChange
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.date_options, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.date,
                                  label: item.date,
                                  value: item.date
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      }),
                      (_ctx.get_is_super(false))
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                            default: _withId(() => [
                              _createVNode(_component_el_button, {
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogAddFormVisible = true)),
                                type: "primary"
                              }, {
                                default: _withId(() => [
                                  _hoisted_3
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.type == 2)
                        ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                            default: _withId(() => [
                              _createVNode(_component_el_button, {
                                onClick: _ctx.tapClick,
                                type: "primary"
                              }, {
                                default: _withId(() => [
                                  _hoisted_4
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          (_ctx.get_is_super(true))
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "primary",
                                onClick: _ctx.sendOut,
                                class: "down_img"
                              }, {
                                default: _withId(() => [
                                  _hoisted_5,
                                  _hoisted_6
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_8,
                                    _hoisted_9,
                                    _hoisted_10,
                                    _hoisted_11,
                                    _hoisted_12,
                                    _hoisted_13,
                                    _hoisted_14
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[11] || (_cache[11] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_15
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_16
                              ]),
                              _: 1
                            }),
                            (_ctx.autoBtnShow)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  size: "mini",
                                  onClick: _ctx.autoAdd
                                }, {
                                  default: _withId(() => [
                                    _hoisted_17
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_18, [
                    _createVNode("div", _hoisted_19, [
                      (_ctx.type != 2)
                        ? (_openBlock(), _createBlock("img", _hoisted_20))
                        : (_openBlock(), _createBlock("img", _hoisted_21))
                    ])
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataList, (item) => {
                    return (_openBlock(), _createBlock("div", { key: item }, [
                      _createVNode("span", {
                        style: {
                  color: _ctx.type == 2 ? '#5f5db0' : '#a04343',
                  fontWeight: 'bold',
                }
                      }, [
                        _createVNode("span", _hoisted_22, _toDisplayString(_ctx.getDescription(_ctx.type, item)) + _toDisplayString(_ctx.type == "2" ? (item == "预约榜" ? "预约" : "热搜") : "预约") + _toDisplayString(item == "change_list" ? "增量" : "") + "TOP20", 1),
                        _createVNode("span", _hoisted_23, "数据更新时间：" + _toDisplayString(_ctx.type == 0
                      ? item == "qq"
                        ? _ctx.gamesData.qq_time
                        : _ctx.gamesData.wechat_time
                      : _ctx.type == 1
                      ? _ctx.gamesData.time
                      : _ctx.gamesData.qq_time), 1)
                      ], 4),
                      _withDirectives(_createVNode("div", _hoisted_24, [
                        _createVNode(_component_el_table, {
                          data: _ctx.gamesData[item],
                          border: "",
                          size: "default",
                          "header-cell-style": _ctx.headerCellStyle
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              width: _ctx.type == 2 ? 200 : '',
                              align: "center",
                              label: _ctx.type == 2 ? 'Top排行' : '预约Top'
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  class: _ctx.getIcon(scope.$index)
                                }, null, 2),
                                (
                          scope.$index !== 0 &&
                          scope.$index !== 1 &&
                          scope.$index !== 2
                        )
                                  ? (_openBlock(), _createBlock("span", _hoisted_25, _toDisplayString(scope.$index + 1), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["width", "label"]),
                            _createVNode(_component_el_table_column, {
                              width: _ctx.type == 2 ? (item == '预约榜' ? 470 : '') : '350',
                              label: "游戏名"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("div", _hoisted_26, [
                                  _createVNode("span", _hoisted_27, [
                                    _createVNode("img", {
                                      src: scope.row.icon
                                    }, null, 8, ["src"])
                                  ]),
                                  _createVNode("div", null, [
                                    _createVNode("div", _hoisted_28, _toDisplayString(scope.row.project_name), 1),
                                    (_ctx.type == 2 && item == '预约榜')
                                      ? (_openBlock(), _createBlock("div", _hoisted_29, _toDisplayString(scope.row.desc), 1))
                                      : (_openBlock(), _createBlock("div", _hoisted_30, _toDisplayString(scope.row.desc), 1))
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1032, ["width"]),
                            (_ctx.type == 1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 0,
                                  align: "center",
                                  label: "\n                    官网\n                    "
                                }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(scope.row.official_num), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.type == 1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 1,
                                  align: "center",
                                  label: "\n                    微信\n                    "
                                }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(scope.row.wechat_num), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.type == 1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 2,
                                  align: "center",
                                  label: "\n                    手Q\n                    "
                                }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(scope.row.qq_num), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (item != 'Tap游戏热搜')
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 3,
                                  align: "center",
                                  label: 
                      _ctx.type == 0
                        ? (item == 'qq' ? '手Q' : '微信') + '平台预约数'
                        : _ctx.type == 1
                        ? '双平台总预约数'
                        : item == '预约榜'
                        ? 'TapTap预约数'
                        : 'TapTap热搜'
                    
                                }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(_ctx.type == 0
                          ? scope.row.wechat_num
                          : _ctx.type == "1"
                          ? scope.row.sum
                          : scope.row.reserve_count), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              : _createCommentVNode("", true),
                            (item != 'Tap游戏热搜')
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 4,
                                  align: "center",
                                  label: '变化趋势(' + _ctx.date_text + ')'
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", {
                                      style: 
                          'color:' +
                          (scope.row.change.indexOf('+') != -1
                            ? 'red'
                            : '#00b050')
                        
                                    }, _toDisplayString(scope.row.change), 5)
                                  ]),
                                  _: 1
                                }, 8, ["label"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["data", "header-cell-style"])
                      ], 512), [
                        [_directive_loading, _ctx.tableLoading]
                      ])
                    ]))
                  }), 128)),
                  _createVNode("div", null, [
                    _createVNode(_component_el_dialog, {
                      width: "615px",
                      modelValue: _ctx.dialogAddFormVisible,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.dialogAddFormVisible = $event))
                    }, {
                      footer: _withId(() => [
                        _createVNode("span", _hoisted_31, [
                          _createVNode(_component_el_button, {
                            size: "small",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.resetAddForm('ruleaddForm'))),
                            type: "info"
                          }, {
                            default: _withId(() => [
                              _hoisted_32
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            size: "small",
                            type: "primary",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.submitAddForm()))
                          }, {
                            default: _withId(() => [
                              _hoisted_33
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      default: _withId(() => [
                        _createVNode(_component_el_form, {
                          size: "mini",
                          style: {"display":"flex","flex-direction":"column","align-items":"flex-start"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              "label-width": "90px",
                              style: {"width":"500px"},
                              label: "获取URL"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.url,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.url = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              "label-width": "90px",
                              style: {"width":"500px","margin":"20px 0"},
                              label: "手Q skey"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.skey,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.skey = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              "label-width": "90px",
                              style: {"width":"500px","margin":"20px 0"},
                              label: "手Q p_skey"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.p_skey,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.p_skey = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              (_ctx.backShow)
                ? (_openBlock(), _createBlock("div", _hoisted_34))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})